import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as propTypes from 'prop-types';
import VirtualList, { ItemStyle } from 'react-tiny-virtual-list';
import { ALIGNMENT } from 'react-tiny-virtual-list/types/constants';
import { Organization } from '../../lib/types/types';


interface OrganizationListProps {
    getItemProps: any;
    getMenuProps: any;
    highlightedIndex: number;
    itemToString: any;
    organizations: Organization[];
}

const ROW_HEIGHT = 42;
const AUTO_SCROLL = 'auto' as ALIGNMENT.AUTO;

const OrganizationList = ({ getItemProps, getMenuProps, highlightedIndex, organizations, itemToString }: OrganizationListProps) => {
    const fullHeight = organizations.length * ROW_HEIGHT;
    const itemCount = organizations.length;

    const item = (index: number, style: ItemStyle) => {
        return (
            <div
                className={`sid-organization-list__item ${highlightedIndex === index ? 'sid-organization-list__item--highlighted' : ''}`}
                key={organizations[index].id}
                {...getItemProps({
                    style,
                    index,
                    item: organizations[index],
                })}
                >
                {itemToString(organizations[index])}
            </div>
        );
    };

    return(
        <VirtualList
            {...getMenuProps()}
            className={'sid-organization-list__menu'}
            height={Math.min(fullHeight, 280)}
            itemCount={itemCount}
            itemSize={ROW_HEIGHT}
            renderItem={({ index, style }) => item(index, { ...style, width: 'auto' })}
            scrollToAlignment={AUTO_SCROLL}
            scrollToIndex={highlightedIndex || 0}
            tabIndex={-1}
            width={'100%'}
        />
    );
};

OrganizationList.propTypes = {
    getItemProps: propTypes.func.isRequired,
    itemToString: propTypes.func.isRequired,
    highlightedIndex: propTypes.number.isRequired,
    organizations: propTypes.array.isRequired,
};

export const OrganizationListComponent = OrganizationList;
